import React, { Component } from "react";
import { ROUTE_HOME } from "../shared/constants";
import Loading from "../../shared/Loading/Loading";
import { redirectToLogin } from "../../../js/shared/utils";

class RedirectSimulator extends Component {
	constructor() {
		super();
		this.state = {};
	}

	componentDidMount() {
		window.history.pushState(ROUTE_HOME.toString(), document.title, ROUTE_HOME);
		redirectToLogin(window);
	}

	render() {
		return <Loading />;
	}
}

export default RedirectSimulator;
